import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'tireBrand',
  title: 'Tire Brands/Models',
  type: 'document',
  orderings: [
    {
      title: 'Name A-Z',
      name: 'nameAsc',
      by: [{field: 'name', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'name',
      title: 'Name',
      type: 'string',
      validation: (rule: any) => rule.required(),
    }),
    defineField({
      name: 'tireType',
      title: 'Tire Type',
      type: 'reference',
      to: [{ type: 'tireType' }],
      options: {
        disableNew: true,
      },
    }),
  ],
})